export default "__VITE_ASSET__lxOirmlo__"